// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__h142s","slider":"switch_slider__-QDEo"};